/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { HalJson } from '../models/hal-json';
import { ItemAndItemVariantAssociationResult } from '../models/item-and-item-variant-association-result';
import { ItemVariantGroupResult } from '../models/item-variant-group-result';
import { itemVariantGroupsGet } from '../fn/item-variants/item-variant-groups-get';
import { ItemVariantGroupsGet$Params } from '../fn/item-variants/item-variant-groups-get';
import { itemVariantGroupsItemVariantGroupIdAssociationTypesPut } from '../fn/item-variants/item-variant-groups-item-variant-group-id-association-types-put';
import { ItemVariantGroupsItemVariantGroupIdAssociationTypesPut$Params } from '../fn/item-variants/item-variant-groups-item-variant-group-id-association-types-put';
import { itemVariantGroupsItemVariantGroupIdDelete } from '../fn/item-variants/item-variant-groups-item-variant-group-id-delete';
import { ItemVariantGroupsItemVariantGroupIdDelete$Params } from '../fn/item-variants/item-variant-groups-item-variant-group-id-delete';
import { itemVariantGroupsItemVariantGroupIdGet } from '../fn/item-variants/item-variant-groups-item-variant-group-id-get';
import { ItemVariantGroupsItemVariantGroupIdGet$Params } from '../fn/item-variants/item-variant-groups-item-variant-group-id-get';
import { itemVariantGroupsItemVariantGroupIdItemSelectionsGet } from '../fn/item-variants/item-variant-groups-item-variant-group-id-item-selections-get';
import { ItemVariantGroupsItemVariantGroupIdItemSelectionsGet$Params } from '../fn/item-variants/item-variant-groups-item-variant-group-id-item-selections-get';
import { itemVariantGroupsItemVariantGroupIdItemSelectionsPut } from '../fn/item-variants/item-variant-groups-item-variant-group-id-item-selections-put';
import { ItemVariantGroupsItemVariantGroupIdItemSelectionsPut$Params } from '../fn/item-variants/item-variant-groups-item-variant-group-id-item-selections-put';
import { itemVariantGroupsItemVariantGroupIdPut } from '../fn/item-variants/item-variant-groups-item-variant-group-id-put';
import { ItemVariantGroupsItemVariantGroupIdPut$Params } from '../fn/item-variants/item-variant-groups-item-variant-group-id-put';
import { itemVariantGroupsPost } from '../fn/item-variants/item-variant-groups-post';
import { ItemVariantGroupsPost$Params } from '../fn/item-variants/item-variant-groups-post';
import { ItemVariantResult } from '../models/item-variant-result';
import { itemVariantsGet } from '../fn/item-variants/item-variants-get';
import { ItemVariantsGet$Params } from '../fn/item-variants/item-variants-get';
import { itemVariantsItemVariantIdDelete } from '../fn/item-variants/item-variants-item-variant-id-delete';
import { ItemVariantsItemVariantIdDelete$Params } from '../fn/item-variants/item-variants-item-variant-id-delete';
import { itemVariantsItemVariantIdGet } from '../fn/item-variants/item-variants-item-variant-id-get';
import { ItemVariantsItemVariantIdGet$Params } from '../fn/item-variants/item-variants-item-variant-id-get';
import { itemVariantsItemVariantIdPut } from '../fn/item-variants/item-variants-item-variant-id-put';
import { ItemVariantsItemVariantIdPut$Params } from '../fn/item-variants/item-variants-item-variant-id-put';
import { itemVariantsPost } from '../fn/item-variants/item-variants-post';
import { ItemVariantsPost$Params } from '../fn/item-variants/item-variants-post';
import { ItemVariantTypeResult } from '../models/item-variant-type-result';
import { itemVariantTypesGet } from '../fn/item-variants/item-variant-types-get';
import { ItemVariantTypesGet$Params } from '../fn/item-variants/item-variant-types-get';
import { itemVariantTypesItemVariantTypeIdAssociationVariantsPut } from '../fn/item-variants/item-variant-types-item-variant-type-id-association-variants-put';
import { ItemVariantTypesItemVariantTypeIdAssociationVariantsPut$Params } from '../fn/item-variants/item-variant-types-item-variant-type-id-association-variants-put';
import { itemVariantTypesItemVariantTypeIdDelete } from '../fn/item-variants/item-variant-types-item-variant-type-id-delete';
import { ItemVariantTypesItemVariantTypeIdDelete$Params } from '../fn/item-variants/item-variant-types-item-variant-type-id-delete';
import { itemVariantTypesItemVariantTypeIdGet } from '../fn/item-variants/item-variant-types-item-variant-type-id-get';
import { ItemVariantTypesItemVariantTypeIdGet$Params } from '../fn/item-variants/item-variant-types-item-variant-type-id-get';
import { itemVariantTypesItemVariantTypeIdPut } from '../fn/item-variants/item-variant-types-item-variant-type-id-put';
import { ItemVariantTypesItemVariantTypeIdPut$Params } from '../fn/item-variants/item-variant-types-item-variant-type-id-put';
import { itemVariantTypesPost } from '../fn/item-variants/item-variant-types-post';
import { ItemVariantTypesPost$Params } from '../fn/item-variants/item-variant-types-post';

@Injectable({ providedIn: 'root' })
export class ItemVariantsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `itemVariantsGet()` */
  static readonly ItemVariantsGetPath = '/item-variants';

  /**
   * Retrieve all Item Variants for a tenant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `itemVariantsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  itemVariantsGet$Response(params: ItemVariantsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: HalJson;
'_embedded'?: {
'itemVariants'?: Array<ItemVariantResult>;
};
}>> {
    return itemVariantsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve all Item Variants for a tenant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `itemVariantsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  itemVariantsGet(params: ItemVariantsGet$Params, context?: HttpContext): Observable<{
'_links'?: HalJson;
'_embedded'?: {
'itemVariants'?: Array<ItemVariantResult>;
};
}> {
    return this.itemVariantsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'_links'?: HalJson;
'_embedded'?: {
'itemVariants'?: Array<ItemVariantResult>;
};
}>): {
'_links'?: HalJson;
'_embedded'?: {
'itemVariants'?: Array<ItemVariantResult>;
};
} => r.body)
    );
  }

  /** Path part for operation `itemVariantsPost()` */
  static readonly ItemVariantsPostPath = '/item-variants';

  /**
   * Create a Variant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `itemVariantsPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  itemVariantsPost$Response(params: ItemVariantsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: HalJson;
'itemVariantId'?: string;
}>> {
    return itemVariantsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a Variant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `itemVariantsPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  itemVariantsPost(params: ItemVariantsPost$Params, context?: HttpContext): Observable<{
'_links'?: HalJson;
'itemVariantId'?: string;
}> {
    return this.itemVariantsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'_links'?: HalJson;
'itemVariantId'?: string;
}>): {
'_links'?: HalJson;
'itemVariantId'?: string;
} => r.body)
    );
  }

  /** Path part for operation `itemVariantsItemVariantIdGet()` */
  static readonly ItemVariantsItemVariantIdGetPath = '/item-variants/{itemVariantId}';

  /**
   * Get a Variant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `itemVariantsItemVariantIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  itemVariantsItemVariantIdGet$Response(params: ItemVariantsItemVariantIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: HalJson;
} & ItemVariantResult>> {
    return itemVariantsItemVariantIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a Variant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `itemVariantsItemVariantIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  itemVariantsItemVariantIdGet(params: ItemVariantsItemVariantIdGet$Params, context?: HttpContext): Observable<{
'_links'?: HalJson;
} & ItemVariantResult> {
    return this.itemVariantsItemVariantIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'_links'?: HalJson;
} & ItemVariantResult>): {
'_links'?: HalJson;
} & ItemVariantResult => r.body)
    );
  }

  /** Path part for operation `itemVariantsItemVariantIdPut()` */
  static readonly ItemVariantsItemVariantIdPutPath = '/item-variants/{itemVariantId}';

  /**
   * Update a Variant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `itemVariantsItemVariantIdPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  itemVariantsItemVariantIdPut$Response(params: ItemVariantsItemVariantIdPut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return itemVariantsItemVariantIdPut(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a Variant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `itemVariantsItemVariantIdPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  itemVariantsItemVariantIdPut(params: ItemVariantsItemVariantIdPut$Params, context?: HttpContext): Observable<void> {
    return this.itemVariantsItemVariantIdPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `itemVariantsItemVariantIdDelete()` */
  static readonly ItemVariantsItemVariantIdDeletePath = '/item-variants/{itemVariantId}';

  /**
   * Delete a Variant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `itemVariantsItemVariantIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  itemVariantsItemVariantIdDelete$Response(params: ItemVariantsItemVariantIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return itemVariantsItemVariantIdDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a Variant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `itemVariantsItemVariantIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  itemVariantsItemVariantIdDelete(params: ItemVariantsItemVariantIdDelete$Params, context?: HttpContext): Observable<void> {
    return this.itemVariantsItemVariantIdDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `itemVariantTypesGet()` */
  static readonly ItemVariantTypesGetPath = '/item-variant-types';

  /**
   * Retrieve all Item Variant Types for a tenant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `itemVariantTypesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  itemVariantTypesGet$Response(params: ItemVariantTypesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: HalJson;
'_embedded'?: {
'itemVariants'?: Array<ItemVariantTypeResult>;
};
}>> {
    return itemVariantTypesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve all Item Variant Types for a tenant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `itemVariantTypesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  itemVariantTypesGet(params: ItemVariantTypesGet$Params, context?: HttpContext): Observable<{
'_links'?: HalJson;
'_embedded'?: {
'itemVariants'?: Array<ItemVariantTypeResult>;
};
}> {
    return this.itemVariantTypesGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'_links'?: HalJson;
'_embedded'?: {
'itemVariants'?: Array<ItemVariantTypeResult>;
};
}>): {
'_links'?: HalJson;
'_embedded'?: {
'itemVariants'?: Array<ItemVariantTypeResult>;
};
} => r.body)
    );
  }

  /** Path part for operation `itemVariantTypesPost()` */
  static readonly ItemVariantTypesPostPath = '/item-variant-types';

  /**
   * Create a Variant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `itemVariantTypesPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  itemVariantTypesPost$Response(params: ItemVariantTypesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: HalJson;
'itemVariantTypeId'?: string;
}>> {
    return itemVariantTypesPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a Variant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `itemVariantTypesPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  itemVariantTypesPost(params: ItemVariantTypesPost$Params, context?: HttpContext): Observable<{
'_links'?: HalJson;
'itemVariantTypeId'?: string;
}> {
    return this.itemVariantTypesPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'_links'?: HalJson;
'itemVariantTypeId'?: string;
}>): {
'_links'?: HalJson;
'itemVariantTypeId'?: string;
} => r.body)
    );
  }

  /** Path part for operation `itemVariantTypesItemVariantTypeIdGet()` */
  static readonly ItemVariantTypesItemVariantTypeIdGetPath = '/item-variant-types/{itemVariantTypeId}';

  /**
   * Get a Variant Type.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `itemVariantTypesItemVariantTypeIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  itemVariantTypesItemVariantTypeIdGet$Response(params: ItemVariantTypesItemVariantTypeIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: HalJson;
} & ItemVariantResult>> {
    return itemVariantTypesItemVariantTypeIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a Variant Type.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `itemVariantTypesItemVariantTypeIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  itemVariantTypesItemVariantTypeIdGet(params: ItemVariantTypesItemVariantTypeIdGet$Params, context?: HttpContext): Observable<{
'_links'?: HalJson;
} & ItemVariantResult> {
    return this.itemVariantTypesItemVariantTypeIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'_links'?: HalJson;
} & ItemVariantResult>): {
'_links'?: HalJson;
} & ItemVariantResult => r.body)
    );
  }

  /** Path part for operation `itemVariantTypesItemVariantTypeIdPut()` */
  static readonly ItemVariantTypesItemVariantTypeIdPutPath = '/item-variant-types/{itemVariantTypeId}';

  /**
   * Update a Variant Type.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `itemVariantTypesItemVariantTypeIdPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  itemVariantTypesItemVariantTypeIdPut$Response(params: ItemVariantTypesItemVariantTypeIdPut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return itemVariantTypesItemVariantTypeIdPut(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a Variant Type.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `itemVariantTypesItemVariantTypeIdPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  itemVariantTypesItemVariantTypeIdPut(params: ItemVariantTypesItemVariantTypeIdPut$Params, context?: HttpContext): Observable<void> {
    return this.itemVariantTypesItemVariantTypeIdPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `itemVariantTypesItemVariantTypeIdDelete()` */
  static readonly ItemVariantTypesItemVariantTypeIdDeletePath = '/item-variant-types/{itemVariantTypeId}';

  /**
   * Delete a Variant Type.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `itemVariantTypesItemVariantTypeIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  itemVariantTypesItemVariantTypeIdDelete$Response(params: ItemVariantTypesItemVariantTypeIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return itemVariantTypesItemVariantTypeIdDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a Variant Type.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `itemVariantTypesItemVariantTypeIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  itemVariantTypesItemVariantTypeIdDelete(params: ItemVariantTypesItemVariantTypeIdDelete$Params, context?: HttpContext): Observable<void> {
    return this.itemVariantTypesItemVariantTypeIdDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `itemVariantTypesItemVariantTypeIdAssociationVariantsPut()` */
  static readonly ItemVariantTypesItemVariantTypeIdAssociationVariantsPutPath = '/item-variant-types/{itemVariantTypeId}/association/variants';

  /**
   * Associate Variants to a Variant Type.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `itemVariantTypesItemVariantTypeIdAssociationVariantsPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  itemVariantTypesItemVariantTypeIdAssociationVariantsPut$Response(params: ItemVariantTypesItemVariantTypeIdAssociationVariantsPut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return itemVariantTypesItemVariantTypeIdAssociationVariantsPut(this.http, this.rootUrl, params, context);
  }

  /**
   * Associate Variants to a Variant Type.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `itemVariantTypesItemVariantTypeIdAssociationVariantsPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  itemVariantTypesItemVariantTypeIdAssociationVariantsPut(params: ItemVariantTypesItemVariantTypeIdAssociationVariantsPut$Params, context?: HttpContext): Observable<void> {
    return this.itemVariantTypesItemVariantTypeIdAssociationVariantsPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `itemVariantGroupsGet()` */
  static readonly ItemVariantGroupsGetPath = '/item-variant-groups';

  /**
   * Retrieve all Item Variant Types for a tenant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `itemVariantGroupsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  itemVariantGroupsGet$Response(params: ItemVariantGroupsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: HalJson;
'_embedded'?: {
'itemVariants'?: Array<ItemVariantGroupResult>;
};
}>> {
    return itemVariantGroupsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve all Item Variant Types for a tenant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `itemVariantGroupsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  itemVariantGroupsGet(params: ItemVariantGroupsGet$Params, context?: HttpContext): Observable<{
'_links'?: HalJson;
'_embedded'?: {
'itemVariants'?: Array<ItemVariantGroupResult>;
};
}> {
    return this.itemVariantGroupsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'_links'?: HalJson;
'_embedded'?: {
'itemVariants'?: Array<ItemVariantGroupResult>;
};
}>): {
'_links'?: HalJson;
'_embedded'?: {
'itemVariants'?: Array<ItemVariantGroupResult>;
};
} => r.body)
    );
  }

  /** Path part for operation `itemVariantGroupsPost()` */
  static readonly ItemVariantGroupsPostPath = '/item-variant-groups';

  /**
   * Create a Variant Group.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `itemVariantGroupsPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  itemVariantGroupsPost$Response(params: ItemVariantGroupsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: HalJson;
'itemVariantGroupId'?: string;
}>> {
    return itemVariantGroupsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a Variant Group.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `itemVariantGroupsPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  itemVariantGroupsPost(params: ItemVariantGroupsPost$Params, context?: HttpContext): Observable<{
'_links'?: HalJson;
'itemVariantGroupId'?: string;
}> {
    return this.itemVariantGroupsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'_links'?: HalJson;
'itemVariantGroupId'?: string;
}>): {
'_links'?: HalJson;
'itemVariantGroupId'?: string;
} => r.body)
    );
  }

  /** Path part for operation `itemVariantGroupsItemVariantGroupIdGet()` */
  static readonly ItemVariantGroupsItemVariantGroupIdGetPath = '/item-variant-groups/{itemVariantGroupId}';

  /**
   * Get a Variant Type.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `itemVariantGroupsItemVariantGroupIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  itemVariantGroupsItemVariantGroupIdGet$Response(params: ItemVariantGroupsItemVariantGroupIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: HalJson;
} & ItemVariantGroupResult>> {
    return itemVariantGroupsItemVariantGroupIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a Variant Type.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `itemVariantGroupsItemVariantGroupIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  itemVariantGroupsItemVariantGroupIdGet(params: ItemVariantGroupsItemVariantGroupIdGet$Params, context?: HttpContext): Observable<{
'_links'?: HalJson;
} & ItemVariantGroupResult> {
    return this.itemVariantGroupsItemVariantGroupIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'_links'?: HalJson;
} & ItemVariantGroupResult>): {
'_links'?: HalJson;
} & ItemVariantGroupResult => r.body)
    );
  }

  /** Path part for operation `itemVariantGroupsItemVariantGroupIdPut()` */
  static readonly ItemVariantGroupsItemVariantGroupIdPutPath = '/item-variant-groups/{itemVariantGroupId}';

  /**
   * Update a Variant Group.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `itemVariantGroupsItemVariantGroupIdPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  itemVariantGroupsItemVariantGroupIdPut$Response(params: ItemVariantGroupsItemVariantGroupIdPut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return itemVariantGroupsItemVariantGroupIdPut(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a Variant Group.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `itemVariantGroupsItemVariantGroupIdPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  itemVariantGroupsItemVariantGroupIdPut(params: ItemVariantGroupsItemVariantGroupIdPut$Params, context?: HttpContext): Observable<void> {
    return this.itemVariantGroupsItemVariantGroupIdPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `itemVariantGroupsItemVariantGroupIdDelete()` */
  static readonly ItemVariantGroupsItemVariantGroupIdDeletePath = '/item-variant-groups/{itemVariantGroupId}';

  /**
   * Delete a Variant Type.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `itemVariantGroupsItemVariantGroupIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  itemVariantGroupsItemVariantGroupIdDelete$Response(params: ItemVariantGroupsItemVariantGroupIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return itemVariantGroupsItemVariantGroupIdDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a Variant Type.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `itemVariantGroupsItemVariantGroupIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  itemVariantGroupsItemVariantGroupIdDelete(params: ItemVariantGroupsItemVariantGroupIdDelete$Params, context?: HttpContext): Observable<void> {
    return this.itemVariantGroupsItemVariantGroupIdDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `itemVariantGroupsItemVariantGroupIdAssociationTypesPut()` */
  static readonly ItemVariantGroupsItemVariantGroupIdAssociationTypesPutPath = '/item-variant-groups/{itemVariantGroupId}/association/types';

  /**
   * Associate Variant Types to a Variant Group.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `itemVariantGroupsItemVariantGroupIdAssociationTypesPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  itemVariantGroupsItemVariantGroupIdAssociationTypesPut$Response(params: ItemVariantGroupsItemVariantGroupIdAssociationTypesPut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return itemVariantGroupsItemVariantGroupIdAssociationTypesPut(this.http, this.rootUrl, params, context);
  }

  /**
   * Associate Variant Types to a Variant Group.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `itemVariantGroupsItemVariantGroupIdAssociationTypesPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  itemVariantGroupsItemVariantGroupIdAssociationTypesPut(params: ItemVariantGroupsItemVariantGroupIdAssociationTypesPut$Params, context?: HttpContext): Observable<void> {
    return this.itemVariantGroupsItemVariantGroupIdAssociationTypesPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `itemVariantGroupsItemVariantGroupIdItemSelectionsGet()` */
  static readonly ItemVariantGroupsItemVariantGroupIdItemSelectionsGetPath = '/item-variant-groups/{itemVariantGroupId}/item-selections';

  /**
   * Get variant-item combinations (all possible combinations).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `itemVariantGroupsItemVariantGroupIdItemSelectionsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  itemVariantGroupsItemVariantGroupIdItemSelectionsGet$Response(params: ItemVariantGroupsItemVariantGroupIdItemSelectionsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: HalJson;
'_embedded'?: {
'itemVariant'?: Array<ItemAndItemVariantAssociationResult>;
};
}>> {
    return itemVariantGroupsItemVariantGroupIdItemSelectionsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get variant-item combinations (all possible combinations).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `itemVariantGroupsItemVariantGroupIdItemSelectionsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  itemVariantGroupsItemVariantGroupIdItemSelectionsGet(params: ItemVariantGroupsItemVariantGroupIdItemSelectionsGet$Params, context?: HttpContext): Observable<{
'_links'?: HalJson;
'_embedded'?: {
'itemVariant'?: Array<ItemAndItemVariantAssociationResult>;
};
}> {
    return this.itemVariantGroupsItemVariantGroupIdItemSelectionsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'_links'?: HalJson;
'_embedded'?: {
'itemVariant'?: Array<ItemAndItemVariantAssociationResult>;
};
}>): {
'_links'?: HalJson;
'_embedded'?: {
'itemVariant'?: Array<ItemAndItemVariantAssociationResult>;
};
} => r.body)
    );
  }

  /** Path part for operation `itemVariantGroupsItemVariantGroupIdItemSelectionsPut()` */
  static readonly ItemVariantGroupsItemVariantGroupIdItemSelectionsPutPath = '/item-variant-groups/{itemVariantGroupId}/item-selections';

  /**
   * Associate variants with items.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `itemVariantGroupsItemVariantGroupIdItemSelectionsPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  itemVariantGroupsItemVariantGroupIdItemSelectionsPut$Response(params: ItemVariantGroupsItemVariantGroupIdItemSelectionsPut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return itemVariantGroupsItemVariantGroupIdItemSelectionsPut(this.http, this.rootUrl, params, context);
  }

  /**
   * Associate variants with items.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `itemVariantGroupsItemVariantGroupIdItemSelectionsPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  itemVariantGroupsItemVariantGroupIdItemSelectionsPut(params: ItemVariantGroupsItemVariantGroupIdItemSelectionsPut$Params, context?: HttpContext): Observable<void> {
    return this.itemVariantGroupsItemVariantGroupIdItemSelectionsPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
